import { user as authUser } from '@/ui/auth/auth';
import {
  GeneralInspectionQuery,
  InspectionQuery,
  IssueQuery,
  QuestionQuery,
} from '@/services/api/resources/analytics/query';
import { useQueryFiltering } from '@/ui/pages/analytics/Overview/useQueryFilters';
import { Status, statusToIssueStatus } from '@/entities/todo';
import { mergeEntityItems } from '../codec';

export const useQueries = () => {
  const queryFilters = useQueryFiltering();

  const {
    start,
    end,
    group,
    entityItem,
    user,
    category,
    checklist,
    questionTitle,
    response,
    section,
    inspection,
    status,
    type,
    priority,
    sensor,
    question,
    entityFolder,
  } = queryFilters;

  //based on filters present on the page
  const baseQuery = () => ({
    timezone: authUser.value.timezone,
    page: 1,
    perPage: 10,
    sort: '',
    dir: '',
    start: start.value,
    end: end.value,
    entityItem: mergeEntityItems(entityFolder.value, entityItem.value),
    group: group.value,
    user: user.value,
    category: category.value,
    checklist: checklist.value,
    questionTitle: questionTitle.value,
    response: response.value,
    section: section.value,
  });
  const issuesQuery = (): IssueQuery => ({
    ...baseQuery(),
    creator: user.value,
    resolver: [],
    question: question.value,
    inspection: inspection.value,
    sensor: sensor.value,
    type: type.value,
    priority: priority.value,
    status: status.value.map(statusToIssueStatus),
    assignee: [],
  });
  const baseQuestionQuery = () => ({
    ...baseQuery(),
    inspector: user.value,
    questionTitle: questionTitle.value,
    response: response.value,
    inspection: inspection.value,
    section: section.value,
    question: [],
  });
  const negativeResponseCardQuery = (): QuestionQuery => ({
    ...baseQuestionQuery(),
    excludeNegativeResponseCount: true,
    hasScore: false,
  });
  const negativeResponseTableQuery = (): QuestionQuery => ({
    ...negativeResponseCardQuery(),
    sort: 'negativeResponseCount',
    dir: 'desc',
  });
  const scoresQuery = (): QuestionQuery => ({
    ...baseQuestionQuery(),
    excludeNegativeResponseCount: false,
    hasScore: true,
  });
  const worstScoresTableQuery = (): QuestionQuery => ({
    ...scoresQuery(),
    sort: 'scorePercentage',
    dir: 'desc',
  });
  const inspectionsQuery = (): GeneralInspectionQuery => ({
    ...baseQuery(),
    assignee: [],
    doneBy: user.value,
    overdue: false,
    status: [Status.Done],
  });
  const inspectionsOverdueQuery = (): InspectionQuery => ({
    ...baseQuery(),
    assignee: user.value,
    overdue: true,
  });
  const mostOverdueInspectionsQuery = (): InspectionQuery => ({
    ...inspectionsOverdueQuery(),
    sort: 'overdueInspectionCount',
    dir: 'desc',
  });

  return {
    baseQuery,
    issuesQuery,
    negativeResponseCardQuery,
    negativeResponseTableQuery,
    scoresQuery,
    worstScoresTableQuery,
    inspectionsQuery,
    inspectionsOverdueQuery,
    mostOverdueInspectionsQuery,
  };
};
